import { render } from "./PrevisualizacionAutorizoDescuento.vue?vue&type=template&id=2c2bcb6c"
import script from "./PrevisualizacionAutorizoDescuento.vue?vue&type=script&lang=js"
export * from "./PrevisualizacionAutorizoDescuento.vue?vue&type=script&lang=js"

import "./PrevisualizacionAutorizoDescuento.vue?vue&type=style&index=0&id=2c2bcb6c&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__